<template>
  <div class="mx-auto grid max-w-[955px] gap-y-12">
    <div
      class="relative skew-y-[-6deg] bg-white/90 px-4 py-24 shadow-2xl sm:px-16 lg:py-32 lg:px-24"
    >
      <div
        class="flex skew-y-[6deg] flex-col items-center justify-center text-dark"
      >
        <slot></slot>
      </div>
      <div
        class="absolute inset-x-0 bottom-0 -mb-px h-[6px]"
        :style="`background: linear-gradient(90deg, #2b3cd6 0%, #3384f8 33%, #ff0053 66%, #fcda2a 100%);`"
      ></div>
    </div>
  </div>
</template>
